export const flowHealthConfigs = [
  {
    componentReference: 'title',
    label: 'Flow health',
    id: 'flow-health',
    cssProps: {
      width: '100%',
      display: 'block',
    },
    count: 4,
  },

  // charts
  {
    componentReference: 'container',
    id: 'flow-health-chart-container1',
    children: [
      {
        containerType: 'flow-health',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'flow_candidate_touchpoint_chart',
        selected: false,
        cssProps: {
          width: '50%',
          display: 'block',
        },
        ui: {
          title: 'Candidate touchpoint',
          id: 'flow_candidate_touchpoint_chart',
          chartData: {
            categories: {
              categories: [
                '07 Oct -\n            13 Oct\n          ',
                '14 Oct -\n            20 Oct\n          ',
                '21 Oct -\n            27 Oct\n          ',
                '28 Oct -\n            03 Nov\n          ',
                '04 Nov -\n            10 Nov\n          ',
              ],
            },
            series: [
              {
                name: 'Sent',
                data: [
                  {
                    y: 0,
                  },
                  {
                    y: 55,
                  },
                  {
                    y: 14,
                  },
                  {
                    y: 6,
                  },
                  {
                    y: 4,
                  },
                ],
                color: '#F72585',
              },
              {
                name: 'Opened',
                data: [
                  {
                    y: 0,
                  },
                  {
                    y: 46,
                  },
                  {
                    y: 3,
                  },
                  {
                    y: 3,
                  },
                  {
                    y: 4,
                  },
                ],
                color: '#6930C3',
              },
              {
                name: 'Replied',
                data: [
                  {
                    y: 0,
                  },
                  {
                    y: 27,
                  },
                  {
                    y: 2,
                  },
                  {
                    y: 0,
                  },
                  {
                    y: 4,
                  },
                ],
                color: '#4361EE',
              },
              {
                name: 'Interested',
                data: [
                  {
                    y: 0,
                  },
                  {
                    y: 18,
                  },
                  {
                    y: 6,
                  },
                  {
                    y: 0,
                  },
                  {
                    y: 0,
                  },
                ],
                color: '#4CA1F0',
              },
            ],
          },
          chartType: 'column',
        },
        api: {
          subject_type: 'flow_health',
          metadata: {
            tileKey: 'flow_candidate_touchpoint_chart',
            componentType: 'chart',
            apiParam: 'flow_health',
            headerKeys: [],
            id: 'flow_candidate_touchpoint_chart',
          },
        },
      },
      {
        containerType: 'flow-health',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'flow_user_activity_chart',
        selected: false,
        cssProps: {
          width: '50%',
          display: 'block',
        },
        ui: {
          title: 'User activity',
          id: 'flow_user_activity_chart',
          chartData: {
            categories: [
              '07 Oct -\n            13 Oct\n          ',
              '14 Oct -\n            20 Oct\n          ',
              '21 Oct -\n            27 Oct\n          ',
              '28 Oct -\n            03 Nov\n          ',
              '04 Nov -\n            10 Nov\n          ',
            ],
            series: [
              {
                name: 'Added',
                data: [
                  {
                    y: 1,
                  },
                  {
                    y: 762,
                  },
                  {
                    y: 32,
                  },
                  {
                    y: 3,
                  },
                  {
                    y: 13,
                  },
                ],
                color: '#F72525',
              },
              {
                name: 'First message sent',
                data: [
                  {
                    y: 0,
                  },
                  {
                    y: 55,
                  },
                  {
                    y: 14,
                  },
                  {
                    y: 6,
                  },
                  {
                    y: 4,
                  },
                ],
                color: '#F72585',
              },
              {
                name: 'Follow-up sent',
                data: [
                  {
                    y: 0,
                  },
                  {
                    y: 2,
                  },
                  {
                    y: 0,
                  },
                  {
                    y: 1,
                  },
                  {
                    y: 0,
                  },
                ],
                color: '#6930C3',
              },
              {
                name: 'Replied',
                data: [
                  {
                    y: 0,
                  },
                  {
                    y: 27,
                  },
                  {
                    y: 2,
                  },
                  {
                    y: 0,
                  },
                  {
                    y: 4,
                  },
                ],
                color: '#4361EE',
              },
              {
                name: 'Interested',
                data: [
                  {
                    y: 2,
                  },
                  {
                    y: 60,
                  },
                  {
                    y: 23,
                  },
                  {
                    y: 0,
                  },
                  {
                    y: 3,
                  },
                ],
                color: '#4CA1F0',
              },
            ],
          },
          chartType: 'column',
        },
        api: {
          subject_type: 'flow_health',
          metadata: {
            tileKey: 'flow_user_activity_chart',
            componentType: 'chart',
            apiParam: 'flow_user_activity',
            headerKeys: [],
            id: 'flow_user_activity_chart',
          },
        },
      },
    ],
  },

  {
    containerType: 'flow-health',
    componentType: 'table',
    componentReference: 'table',
    id: 'flow_health',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Candidate touchpoint table',
      id: 'flow_health',
      tableData: [
        {
          ds: '0',
          dt: 0,
          g1: null,
          g2: null,
          contacted: 0,
          opened: 0,
          replied: 0,
          interested: 0,
          group_by: '2024-W32',
        },
        {
          ds: '0',
          dt: 1,
          g1: null,
          g2: null,
          contacted: 1,
          opened: 1,
          replied: 0,
          interested: 0,
          group_by: '2024-W33',
        },
        {
          ds: '0',
          dt: 2,
          g1: null,
          g2: null,
          contacted: 1,
          opened: 1,
          replied: 0,
          interested: 0,
          group_by: '2024-W34',
        },
        {
          ds: '0',
          dt: 3,
          g1: null,
          g2: null,
          contacted: 9,
          opened: 2,
          replied: 0,
          interested: 0,
          group_by: '2024-W35',
        },
        {
          ds: '0',
          dt: 4,
          g1: null,
          g2: null,
          contacted: 0,
          opened: 0,
          replied: 0,
          interested: 0,
          group_by: '2024-W36',
        },
        {
          ds: '0',
          dt: 5,
          g1: null,
          g2: null,
          contacted: 1,
          opened: 1,
          replied: 0,
          interested: 0,
          group_by: '2024-W37',
        },
        {
          ds: '0',
          dt: 6,
          g1: null,
          g2: null,
          contacted: 0,
          opened: 0,
          replied: 0,
          interested: 0,
          group_by: '2024-W38',
        },
        {
          ds: '0',
          dt: 7,
          g1: null,
          g2: null,
          contacted: 0,
          opened: 0,
          replied: 0,
          interested: 0,
          group_by: '2024-W39',
        },
        {
          ds: '0',
          dt: 8,
          g1: null,
          g2: null,
          contacted: 13,
          opened: 9,
          replied: 0,
          interested: 1,
          group_by: '2024-W40',
        },
        {
          ds: '0',
          dt: 9,
          g1: null,
          g2: null,
          contacted: 14,
          opened: 11,
          replied: 2,
          interested: 4,
          group_by: '2024-W41',
        },
        {
          ds: '0',
          dt: 10,
          g1: null,
          g2: null,
          contacted: 55,
          opened: 46,
          replied: 27,
          interested: 17,
          group_by: '2024-W42',
        },
        {
          ds: '0',
          dt: 11,
          g1: null,
          g2: null,
          contacted: 14,
          opened: 3,
          replied: 2,
          interested: 6,
          group_by: '2024-W43',
        },
        {
          ds: '0',
          dt: 12,
          g1: null,
          g2: null,
          contacted: 6,
          opened: 2,
          replied: 0,
          interested: 0,
          group_by: '2024-W44',
        },
        {
          ds: '0',
          dt: 13,
          g1: null,
          g2: null,
          contacted: 0,
          opened: 0,
          replied: 0,
          interested: 0,
          group_by: '2024-W45',
        },
      ],
    },
    api: {
      id: 'flow_health',
      subject_type: 'flow_health',
      componentType: 'table',
      filters: {
        metrics: {
          id: 'overall',
          label: 'Overall rate',
        },
        group_by_1: {
          id: null,
          label: 'Time',
        },
        group_by_2: {
          id: null,
          label: 'None',
        },
      },
      metadata: {
        tileKey: 'flow_health',
        componentType: 'table',
        apiParam: 'flow_health',
        headerKeys: ['contacted', 'opened', 'replied', 'interested'],
        id: 'flow_health',
      },
    },
  },
  {
    containerType: 'flow-health',
    componentType: 'table',
    componentReference: 'table',
    id: 'flow_user_activity',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'User activity',
      id: 'flow_user_activity',
      tableData: [
        {
          ds: '0',
          dt: 0,
          g1: null,
          g2: null,
          added: 0,
          sent_first: 0,
          sent_followup: 0,
          replied: 0,
          interested: 0,
          group_by: '2024-W40',
        },
        {
          ds: '0',
          dt: 1,
          g1: null,
          g2: null,
          added: 27,
          sent_first: 14,
          sent_followup: 6,
          replied: 2,
          interested: 7,
          group_by: '2024-W41',
        },
        {
          ds: '0',
          dt: 2,
          g1: null,
          g2: null,
          added: 762,
          sent_first: 55,
          sent_followup: 2,
          replied: 27,
          interested: 60,
          group_by: '2024-W42',
        },
        {
          ds: '0',
          dt: 3,
          g1: null,
          g2: null,
          added: 32,
          sent_first: 14,
          sent_followup: 0,
          replied: 2,
          interested: 23,
          group_by: '2024-W43',
        },
        {
          ds: '0',
          dt: 4,
          g1: null,
          g2: null,
          added: 3,
          sent_first: 6,
          sent_followup: 1,
          replied: 0,
          interested: 0,
          group_by: '2024-W44',
        },
        {
          ds: '0',
          dt: 5,
          g1: null,
          g2: null,
          added: 2,
          sent_first: 0,
          sent_followup: 0,
          replied: 0,
          interested: 0,
          group_by: '2024-W45',
        },
      ],
    },
    api: {
      subject_type: 'flow_user_activity',
      componentType: 'table',
      metadata: {
        tileKey: 'flow_user_activity',
        componentType: 'table',
        apiParam: 'flow_user_activity',
        filters: {
          group_by_1: {
            id: null,
            label: 'Time',
          },
          group_by_2: {
            id: null,
            label: 'None',
          },
        },
        headerKeys: ['contacted', 'opened', 'replied', 'interested'],
        id: 'flow_user_activity',
      },
    },
  },
];

export const flowHealthLayoutConfig = [
  {
    key: 'flow_candidate_touchpoint_chart',
    x: 0,
    y: 0,
    w: 12,
    h: 22,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'flow_user_activity_chart',
    x: 0,
    y: 40,
    w: 12,
    h: 23,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'flow_health',
    x: 0,
    y: 22,
    w: 12,
    h: 18,
    minW: 8,
    minH: 8,
    maxW: 12,
    maxH: 100,
  },
  {
    key: 'flow_user_activity',
    x: 0,
    y: 63,
    w: 12,
    h: 18,
    minW: 8,
    minH: 8,
    maxW: 12,
    maxH: 100,
  },
];
